<template>
  <div class="moblie-sap">
     <div class="moblie-sap-title">
       <img src="../../assets/xxzx.png" alt />
       <span>SAP账户解锁与密码修改</span>
     </div>
     <van-form>
     <van-field
        v-model="form.params.psnCode"
        type="text"
        name="sap账号"
        label="sap账号"
        placeholder="请输入sap账号"
       />
     <van-field
        label="需求类型"
        :value="form.params.needType"
        is-link
        @click="onShowNeedType"
        readonly
       />
       <van-action-sheet v-model="isShow" :actions="typeOption" @select="onselect" close-on-click-action />
     </van-form>
    <template v-if="form.params.needType == '重置密码'">
     <!-- 修改密码框-->
        <div style="margin: 16px;">
            <van-button round block type="info" native-type="submit" @click="submitForm">重置</van-button>
        </div>
    </template>
    <!-- 以下账户解锁 -->
    <template v-if="form.params.needType == '账户解锁'">
      <div style="margin: 20px;">
        <van-button round block type="info" native-type="submit" @click="unLock">解锁</van-button>
      </div>
    </template>
  </div>
</template>
<script>
import * as Api from "../../api/sapwmsApi";
import {
  Form,
  Field,
  DropdownMenu,
  DropdownItem,
  Cell,
  ActionSheet,
  Toast,
  Button,
} from "vant";
export default {
  data() {
    return {
      form: {
        params: {
          needType: "账户解锁", //需求类型,默认的需求类型为账户解锁
          psnCode: "", //工号
        },
      },
      typeOption: [{ name: "账户解锁" }, { name: "重置密码" }],
      isShow: false,
    };
  },
  components: {
    [Button.name]: Button,
    [Form.name]: Form,
    [Field.name]: Field,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [ActionSheet.name]: ActionSheet,
    [Toast.name]: Toast,
  },
  mounted() {},
  methods: {
    onselect(item) {
      this.form.params.needType = item.name;
    },
    onShowNeedType() {
      this.isShow = true;
    },
     submitForm() {//密码修改
      let _this = this;
      let params = {
        type: "pwd",
        account: _this.form.params.psnCode,
        password:"1234.com",
      };
      Api.unLockOrModifyPwd(params).then((res) => {
        if(res.success){
          this.$message({
            message: res.data,
            type: "success",
            offset: 120,
          });
        }else {
          this.$message({
            message: res.msg,
            type: "error",
            offset: 120,
          });
        }

      }) .catch(() => {
          Toast.fail('修改失败！');
        });
    },
    unLock() {//解锁操作
      let _this = this;
      let params = {
        type: "unlock",
        account: _this.form.params.psnCode,
      };
      Api.unLockOrModifyPwd(params)
        .then((res) => {
          if(res.success){
            this.$message({
              message: res.data,
              type: "success",
              offset: 120,
            });
          }else {
            this.$message({
              message: res.msg,
              type: "error",
              offset: 120,
            });
          }
        })
        .catch(() => {
           Toast.fail('解锁失败');
        });
    },
  },
};
</script>
<style scoped>
.moblie-sap-title {
  text-align: center;
  padding: 40px;
  font-size: 18px;
}
.moblie-sap-title span {
  display: inline-block;
  vertical-align: top;
}
.moblie-sap-title img {
  display: inline-block;
  margin-right: 5px;
}
</style>
